import Button from '@components/atoms/button'
import { COURSE_INFO } from '@components/locale-pages/home/courses'
import ResponsiveCourseCard from './responsive-course-card'

type Props = {
  courseCodes: string[]
  description?: JSX.Element
  title?: string
  showAllCoursesButton?: boolean
}

const RecommendedCourses = ({
  showAllCoursesButton,
  courseCodes,
  description,
  title,
}: Props) => {
  return (
    <div className="mt-12 md:mt-16 mb-10 flex flex-col text-grey container mx-auto lg:px-3 pb-5">
      <h2 className="text-2xl md:text-2xl font-600 mb-4 leading-tight">
        {title ?? 'More recommended courses for you'}
      </h2>
      {courseCodes.length !== 0 && (
        <div className="flex flex-wrap justify-around gap-4">
          {courseCodes.map((code, index) => (
            <ResponsiveCourseCard key={index} course={COURSE_INFO[code]} />
          ))}
        </div>
      )}
      {description && <p>{description}</p>}
      {showAllCoursesButton && (
        <a
          href="/courses/"
          target="_blank"
          rel="noopener noreferrer"
          className="w-full lg:w-auto mt-8 mx-auto"
        >
          <Button size="lg" variant="outline" className="w-full lg:w-auto">
            Browse all courses
          </Button>
        </a>
      )}
    </div>
  )
}

export default RecommendedCourses
